import { render, staticRenderFns } from "./DiscosRigidos.vue?vue&type=template&id=bdeee812&"
import script from "./DiscosRigidos.vue?vue&type=script&lang=ts&"
export * from "./DiscosRigidos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports